import { render, staticRenderFns } from "./BetPop.vue?vue&type=template&id=cab56e86&scoped=true&"
import script from "./BetPop.vue?vue&type=script&lang=js&"
export * from "./BetPop.vue?vue&type=script&lang=js&"
import style0 from "./BetPop.vue?vue&type=style&index=0&id=cab56e86&prod&lang=less&"
import style1 from "./BetPop.vue?vue&type=style&index=1&id=cab56e86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab56e86",
  null
  
)

export default component.exports